/**
 * components/controls/ControlSearch.jsx
 */

import { __ } from "@wordpress/i18n";
import { useEffect, useRef, useState } from "@wordpress/element";
import { Search, X } from "lucide-react";
import {
    useCrudListState,
    useCrudListDispatch,
    ACTIONS,
} from "../../context/CrudContext";

export default function ControlSearch() {
    const dispatch = useCrudListDispatch();
    const state = useCrudListState();
    const [local, setLocal] = useState(state.search);
    const debounce = useRef(null);

    useEffect(() => {
        clearTimeout(debounce.current);
        debounce.current = setTimeout(
            () => dispatch({ type: ACTIONS.SET_SEARCH, payload: local }),
            350,
        );
        return () => clearTimeout(debounce.current);
    }, [local]);

    // Sync on external reset
    useEffect(() => {
        setLocal(state.search);
    }, [state.search]);

    return (
        <div className="relative flex-1 sm:flex-initial">
            <Search className="absolute start-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
                type="search"
                placeholder={__("Search rules...", "wpbean-product-gallery-slider-for-woocommerce")}
                value={local}
                onChange={(e) => setLocal(e.target.value)}
                className="w-full ps-10 pe-10 py-2 bg-white border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-accent [&::-webkit-search-cancel-button]:hidden"
            />
            <button
                onClick={() => {
                    setLocal("");
                    dispatch({ type: ACTIONS.SET_SEARCH, payload: "" });
                }}
                className={`absolute end-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 w-4 h-4 flex items-center justify-center transition-all duration-200 ${
                    local
                        ? "opacity-100 scale-100"
                        : "opacity-0 scale-75 pointer-events-none"
                }`}
                aria-label={__("Clear search", "wpbean-product-gallery-slider-for-woocommerce")}
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
}
